export default "__VITE_PUBLIC_ASSET__adae0c1c__"